import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const LogoGoogle: React.FC<IIconProps> = ({
  size = IconSizes.md,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.52 16.2727C27.52 15.4218 27.4436 14.6036 27.3018 13.8182H16V18.46H22.4582C22.18 19.96 21.3345 21.2309 20.0636 22.0818V25.0927H23.9418C26.2109 23.0036 27.52 19.9273 27.52 16.2727Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 28C19.24 28 21.9564 26.9255 23.9418 25.0927L20.0636 22.0818C18.9891 22.8018 17.6145 23.2273 16 23.2273C12.8745 23.2273 10.2291 21.1164 9.28545 18.28H5.27636V21.3891C7.25091 25.3109 11.3091 28 16 28Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.28545 18.28C9.04545 17.56 8.90909 16.7909 8.90909 16C8.90909 15.2091 9.04545 14.44 9.28545 13.72V10.6109H5.27636C4.46364 12.2309 4 14.0636 4 16C4 17.9364 4.46364 19.7691 5.27636 21.3891L9.28545 18.28Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8.77273C17.7618 8.77273 19.3436 9.37818 20.5873 10.5673L24.0291 7.12545C21.9509 5.18909 19.2345 4 16 4C11.3091 4 7.25091 6.68909 5.27636 10.6109L9.28545 13.72C10.2291 10.8836 12.8745 8.77273 16 8.77273Z"
        fill="#EA4335"
      />
    </svg>
  );
};

export default LogoGoogle;
